module.exports = __webpack_public_path__ + "img/loginformcode.b47a944f.svg";